import Cdn from 'utils/assets/Cdn'

export const OTTO_3D = {
  BIG_SMILE_FACE: Cdn.getAssets3dUrl('face/bigsmile.png'),
  SAD: Cdn.getAssets3dUrl('face/sad.png'),
  SMILE: Cdn.getAssets3dUrl('face/smile.png'),
  JUMP: Cdn.getAssets3dUrl('fullbody/jump.png'),
  BIG_HAPPY: Cdn.getAssets3dUrl('halfbody/bighappy.png'),
  BIG_SMILE_HALFBODY: Cdn.getAssets3dUrl('halfbody/bigsmile.png'),
  LOOKING_LEFT_HALFBODY: Cdn.getAssets3dUrl('halfbody/lookingleft.png'),
  BLUSH: Cdn.getAssets3dUrl('halfbody/blush.png'),
  GRIN: Cdn.getAssets3dUrl('halfbody/grin.png'),
  HAPPY: Cdn.getAssets3dUrl('halfbody/happy.png'),
  OK: Cdn.getAssets3dUrl('halfbody/ok.png'),
  OTTO_AND_GIRL: Cdn.getAssets3dUrl('ottoAndKid/ottoAndGirl.png'),
  MOVIE_SESSION3D: Cdn.getImageUrl('otto/otto-pipoca-x1.png'),
  SAD_EMPTY_SHELF: Cdn.getImageUrl('otto/sad-otto-3d.png'),
  SMILE_PURPLE_BG: Cdn.getImageUrl('otto/smile-otto-3d.png'),
  MANY_BOOKS: Cdn.getImageUrl('otto/favorites-otto-3d.png'),
  HAPPY_MOUTH_CLOSED: Cdn.getImageUrl(
    'otto/otto-sorrindo-boca-e-olhos-fechados.png'
  ),
  CONFUSED: Cdn.getImageUrl('otto/otto-com-duvida.png'),
  CONFUSED_WITH_BLUE_BACKGROUND: Cdn.getImageUrl(
    'otto/Otto_confused_blue_background.png'
  )
}
